import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f4997b4e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f4997b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4997b4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4997b4e')) {
      api.createRecord('f4997b4e', component.options)
    } else {
      api.reload('f4997b4e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f4997b4e&scoped=true&", function () {
      api.rerender('f4997b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Ss7mg8owysBL/JS/comp/PopupBox.vue"
export default component.exports